import React, { Component } from "react";
import goldlog from "@ali/goldlog";
import {
  Input,
  CascaderSelect,
  Feedback,
  Balloon
} from '@alife/next';
import { cplRepo, getLogin, queryMobilePhone, sendSmsCode, getCplAuthList, cplAuthDelete } from "../../../../service";
import CountdownButton from "./countdownButton";
import "./index.scss";

const staticData = [
  {
    value: 7 * 24 * 60 * 60 * 1000,
    label: '临时采购（7天）'
  },
  {
    value: 14 * 24 * 60 * 60 * 1000,
    label: '正常采购（14天）'
  },
  {
    value: 30 * 24 * 60 * 60 * 1000,
    label: '生产采购（30天）'
  },
  {
    value: 90 * 24 * 60 * 60 * 1000,
    label: '季度采购（90天）'
  }
]

function formatTimestamp(timestamp) {
  // 创建一个新的 Date 对象
  const date = new Date(timestamp);

  // 获取年份、月份和日期
  const year = date.getFullYear().toString(); // 取后两位
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需加 1
  const day = String(date.getDate()).padStart(2, '0');

  // 返回格式化后的日期字符串
  return `${year}-${month}-${day}`;
}

export default class LeadsCardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardShowState: true,
      keyword: window.pageConfig.keywords,
      mobilePhone: '',
      nlq: '',
      //volumn: '',
      authDeadline:  Date.now() + 604800000,
      isLogin: false,
      isNeedVerification: false,
      formSending: false,
      smsCode: '',
      time: 14 * 24 * 60 * 60 * 1000,
      showHistory: false,
      historyList: [],
      submitFlag: false,
      btnTipVisible: false,
      btnTipId: null
    };

    this.handleChangeCascaderSelect = this.handleChangeCascaderSelect.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getSmsCode = this.getSmsCode.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleSmsCodeChange = this.handleSmsCodeChange.bind(this);
    this.isLogin = this.isLogin.bind(this);
    this.handleToHistory = this.handleToHistory.bind(this);
    this.renderForm = this.renderForm.bind(this);
    this.renderHistory = this.renderHistory.bind(this);
    this.getHistory = this.getHistory.bind(this);
    this.handleBackToForm = this.handleBackToForm.bind(this);
    this.handleStop = this.handleStop.bind(this);
  }

  async componentDidMount() {
    if(this.getItemWithExpiration("closeLeadsCard")) {
      this.setState({
        cardShowState: false,
      });
    }

    try {
      if(!this.getItemWithExpiration("closeLeadsCard") && this.state.cardShowState) {
        goldlog && goldlog.record(
          "/ifission.ifission.leadsCardExp",
          "EXP",
          "position=card"
        );
      } else {
        goldlog && goldlog.record(
          "/ifission.ifission.leadsCardExp",
          "EXP",
          "position=icon"
        );
      }
    } catch (error) {
      console.log(error);
    }

    const isLogin = await getLogin();

    if(isLogin) {
      const mobilePhone = await queryMobilePhone();
      this.setState({
        mobilePhone
      })
    }

    this.setState({
      isLogin
    });
  }

  handleToHistory() {
    this.getHistory();
    this.setState({
      showHistory: true
    })
  }

  async getHistory() {
    const list = await getCplAuthList();
    console.log(list);
    this.setState({
      historyList: list
    })
  }

  handleBackToForm() {
    this.setState({
      showHistory: false
    })
  }

  setItemWithExpiration(key, value) {
    const now = new Date();
    const item = {
        value: value,
        expiry: now.getTime() + 24 * 60 * 60 * 1000 // 当前时间加一天的毫秒数
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  getItemWithExpiration(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    
    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
  }

  handleClose() {
    this.setItemWithExpiration('closeLeadsCard', true);
    this.setState({
      cardShowState: false,
    });
    goldlog.record(
      "/ifission.ifission.leadsCardClk",
      "CLK",
      `position=close`
    );
  }

  handleOpen() {
    this.setState({
      cardShowState: true,
    });

    localStorage.removeItem('closeLeadsCard');

    goldlog.record(
      "/ifission.ifission.leadsCardClk",
      "CLK",
      `position=open`
    );
  }

  handleSmsCodeChange(val) {
    this.setState({
      smsCode: val,
    });
  }

  handleChangeCascaderSelect(time) {
    const currentTimestamp = Date.now();
    let authDeadline = currentTimestamp + time;

    this.setState({
      time,
      authDeadline
    });
  }

  async handleSubmit() {
    if(this.state.submitFlag) {
      return;
    }

    this.setState({
      submitFlag: true
    })

    let {
      keyword,
      mobilePhone,
      nlq,
      //volumn,
      authDeadline,
      isNeedVerification,
      smsCode
    } = this.state;


    if(!this.checkKeyword(keyword)) {
      this.setState({
        submitFlag: false
      })
      return;
    }

    if (!mobilePhone.includes("****")) {
      if(!this.phoneNumberCheck(mobilePhone)) {
        this.setState({
          submitFlag: false
        })
        return;
      }
    } else {
      mobilePhone = "";
    }

    // 存在风险，验证码必填
    if(isNeedVerification) {
      if(!this.checkSmsCodeAndNlq(smsCode, nlq)) {
        this.setState({
          submitFlag: false
        })
        return;
      }
    }

    let params = {
      keyword,
      mobilePhone,
      nlq,
      //volumn,
      authDeadline
    };

    if(smsCode && smsCode.length > 0) {
      params.smsCode = smsCode;
    }

    //console.log(params);

    const res = await cplRepo(params);

    this.setState({
      submitFlag: false
    })

    if (Number(res.code) === 4010) {
      this.setState({
        isNeedVerification: true,
      });
      Feedback.toast.show({
        type: "error",
        content: '请填写验证码',
         size: 'large'
      });
    } else if (res.code === "200") {
      Feedback.toast.show({
        type: "success",
        content: '您的采购需求已提交，请保持电话畅通，商家会尽快联系您',
         size: 'large'
      });

      this.setState({
        isNeedVerification: false,
        keyword: '',
        nlq: '',
        smsCode: '',
        time: 14 * 24 * 60 * 60 * 1000
      });
    } else {
      Feedback.toast.show({
        type: "error",
        content: res.msg,
         size: 'large'
      });
    }

    goldlog.record(
      "/ifission.ifission.leadsCardClk",
      "CLK",
      `position=submit`
    );
  }

  checkKeyword(keyword) {
    if (!keyword || keyword.trim() === "") {
      Feedback.toast.show({
        type: "error",
        content: "采购商品不能为空",
         size: 'large'
      });
      return false;
    }
    return true;
  }

  checkSmsCodeAndNlq(smsCode, nlq) {
    if (!smsCode) {
      Feedback.toast.show({
        type: "error",
        content: '请填写验证码',
        size: 'large'
      });
      return false;
    }
    // 存在风险，留言信息必填
    if (!nlq) {
      Feedback.toast.show({
        type: "error",
        content: '请填写留言信息',
        size: 'large'
      });
      return false;
    }
    return true;
  }

  phoneNumberCheck(phoneNumber) {
    const phoneNumReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
    if ((''+phoneNumber).trim() === "") {
      Feedback.toast.show({
        type: "error",
        content: "电话号码不能为空",
         size: 'large'
      });
      return false;
    } else if (!phoneNumReg.test(phoneNumber)) {
      Feedback.toast.show({
        type: "error",
        content: "请填写正确的电话号码",
         size: 'large'
      });
      return false;
    }
    return true;
  }

  getSmsCode() {
    let {
      mobilePhone,
    } = this.state;

    if (!mobilePhone.includes("****")) { 
      if (this.phoneNumberCheck(mobilePhone)) {
        this.sendSmsCode(mobilePhone);
      }
    } else {
      this.sendSmsCode(null);
    }
  };

  async handleStop(id) {
    const res = await cplAuthDelete(id);
    console.log(res);
    if (res.code === "200") {
      Feedback.toast.show({
        type: "success",
        content: '需求已停止，如需开启请重新提交',
         size: 'large'
      });

      this.getHistory();
    } else {
      Feedback.toast.show({
        type: "error",
        content: res.msg,
         size: 'large'
      });
    }
  }

  isLogin() {
    return this.getCookie("__cn_logon_id__");
  }

  getCookie(sKey) {
		return (
			decodeURIComponent(
				document.cookie.replace(
					new RegExp(
					`(?:(?:^|.*;)\\s*${encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&')}\\s*\\=\\s*([^;]*).*$)|^.*$`
					),
					'$1'
				)
			) || null
		);
	}
  
  async sendSmsCode(mobilePhone) {

    const code = await sendSmsCode(mobilePhone ? mobilePhone + "" : null);
    if (Number(code) === 200) {
      Feedback.toast.show({
        type: "prompt",
        content: "验证码已发送",
         size: 'large'
      });
    } else if (Number(code) === 4012) {
      Feedback.toast.show({
        type: "prompt",
        content: "短信验证码已发送,请稍后再试",
         size: 'large'
      });
    }
  }

  renderForm() {
    const {
      keyword,
      mobilePhone,
      nlq,
      //volumn,
      isNeedVerification,
      smsCode,
      time
    } = this.state;

    return (
      <div>
        <div className="leads-card-content-tip">
          Hi，我是1688采购小助手，为您匹配优质货源，您可以点击提交一键获取专属服务~
        </div>
        
        <div className="leads-card-content-form">
          <div className="leads-card-content-form-item">
            <div className="leads-card-content-form-item-title-wrap">
              <span className="leads-card-content-form-item-required">*</span>
              <span className="leads-card-content-form-item-text">采购商品</span>
            </div>

            <Input
              maxLength={20}
              onChange={(value) => this.setState({ keyword: value })}
              className="leads-card-content-form-item-input"
              value={keyword}
            />
          </div>
          <div className="leads-card-content-form-item">
            <div className="leads-card-content-form-item-title-wrap">
              <span className="leads-card-content-form-item-required">*</span>
              <span className="leads-card-content-form-item-text">联系电话</span>
            </div>
            <Input
              value={mobilePhone}
              maxLength={20}
              onChange={(value) => this.setState({ mobilePhone: value })}
              className="leads-card-content-form-item-input"
            />
          </div>
          {
            isNeedVerification && 
            <div className="leads-card-content-form-item">
              <div className="leads-card-content-form-item-title-wrap">
                <span className="leads-card-content-form-item-required">*</span>
                <span className="leads-card-content-form-item-text">验证码</span>
              </div>
              <Input
                className="leads-card-content-form-item-input-smscode"
                type="phone"
                onChange={this.handleSmsCodeChange}
                value={smsCode}
                //placeholder="验证码"
                style={{
                  display: 'inlineBlock'
                }}
              />
              <CountdownButton buttonClick={this.getSmsCode}></CountdownButton>
            </div>
          }
          {
            /*<div className="leads-card-content-form-item">
            <div className="leads-card-content-form-item-title-wrap">
              <span className="leads-card-content-form-item-text">采购数量</span>
            </div>
            <Input
              value={volumn}
              maxLength={13}
              onChange={(value) => this.setState({ volumn: value })}
              className="leads-card-content-form-item-input"
            />
          </div>
          */}
          <div className="leads-card-content-form-item">
            <div className="leads-card-content-form-item-title-wrap">
              <span className="leads-card-content-form-item-text">详细要求</span>
            </div>
            <textArea
              onChange={(e) => this.setState({ nlq: e.target.value })}
              className="leads-card-content-form-item-textArea"
              placeholder="如：采购数量、用途、物流要求、开票要求等"
              value={nlq}
            />
          </div>
          <div className="leads-card-content-form-item">
            <div className="leads-card-content-form-item-title-wrap">
              <span className="leads-card-content-form-item-text">采购周期</span>
            </div>
            <CascaderSelect 
              dataSource={staticData}
              defaultValue={time}
              onChange={this.handleChangeCascaderSelect} 
              className="leads-card-content-form-item-cascaderSelect"
            />
          </div>
        </div>
        
        {
          !this.isLogin() &&
          <div className="leads-card-content-login">
            <img src='https://img.alicdn.com/imgextra/i2/O1CN0152BmUk1x8nSa1NYdp_!!6000000006399-2-tps-44-44.png' className="leads-card-content-login-icon" />
            未登录提交后无法查询
            <a href={`//login.1688.com/member/signin.htm?Done=${encodeURIComponent(window.location.href)}`} className="leads-card-content-login-link">去登录</a>
          </div> 
        }

        <div className="leads-card-content-protocol">
          点击提交视为同意
          <a
            href="https://terms.alicdn.com/legal-agreement/terms/c_end_product_protocol/20231031181421701/20231031181421701.html?spm=a261y.25179003.0.0.56883aa7cMyD2U"
            target="_blank"
          >
            《用户协议》
          </a>
        </div>

        <div 
          className={`leads-card-content-btn ${this.state.submitFlag ? 'leads-card-content-btn-disabled' : ''}`}
          onClick={this.handleSubmit}
        >
          提交采购需求
        </div>

        {
          this.isLogin() && 
          <div className="leads-card-content-to-history" onClick={this.handleToHistory}>
            查看历史采购需求
          </div>
        }
      </div>
    );
  }

  renderHistory() {
    return (
      <div className="leads-card-content-history">
        {
          this.state.historyList && this.state.historyList.length > 0 ? 
          <div className="leads-card-content-history-list">
            <div className="leads-card-content-history-empty-back" onClick={this.handleBackToForm}>
              <img src="https://img.alicdn.com/imgextra/i4/O1CN010UYxV21jYX5wyxdHB_!!6000000004560-2-tps-212-40.png" className="leads-card-content-history-empty-back-icon" />
            </div>
            <div className="leads-card-content-history-list-content">
              {
                this.state.historyList.map(item => {
                  const balloonTrigger = <div className="leads-card-content-history-list-item-content-line">
                    <span className="leads-card-content-history-list-item-content-line-title">详细需求： </span>
                    {item.nlq}
                  </div>
                  return (
                    <div className="leads-card-content-history-list-item">
                      <div className="leads-card-content-history-list-item-title-line">
                        <Balloon trigger={<div className="leads-card-content-history-list-item-title">求购{item.keyword}</div>}>{item.keyword}</Balloon>
                        <div className="leads-card-content-history-list-item-date">{formatTimestamp(Number(item.submitTime))}提交</div>
                      </div>
                      <div className="leads-card-content-history-list-item-content-line">
                        <span className="leads-card-content-history-list-item-content-line-title">联系电话： </span>
                        {item.mobilePhone}
                      </div>
                      {
                        item.nlq && item.nlq.length > 0 ?
                        <Balloon trigger={balloonTrigger}>{item.nlq}</Balloon>
                        :
                        <div className="leads-card-content-history-list-item-content-line">
                          <span className="leads-card-content-history-list-item-content-line-title">详细需求： </span>
                          {item.nlq}
                        </div>
                      }
                      
                      <div className="leads-card-content-history-list-item-content-line">
                        <span className="leads-card-content-history-list-item-content-line-title">采购截止日期： </span>
                        {formatTimestamp(Number(item.authDeadline))}
                      </div>
                      <Balloon 
                        triggerType="click"
                        trigger={
                          <div 
                            className="leads-card-content-history-list-item-btn"
                            onClick={() => {this.setState({ btnTipVisible: true, btnTipId: item.leadsId })}}
                          >
                              停止采购
                          </div>
                        }
                        closable={false}
                        visible={this.state.btnTipVisible && this.state.btnTipId == item.leadsId}
                      >
                        <div className="leads-card-content-history-list-item-btn-tip">
                          <div className="leads-card-content-history-list-item-btn-tip-text">停止采购后，将不再为您匹配合适的货源</div>
                          <div className="leads-card-content-history-list-item-btn-tip-line">
                            <div 
                              className="leads-card-content-history-list-item-btn-tip-cancel"
                              onClick={() => {this.setState({ btnTipVisible: false })}}
                            >
                              我再想想
                            </div>
                            <div 
                              className="leads-card-content-history-list-item-btn-tip-confirm" 
                              onClick={this.handleStop.bind(this, item.leadsId)}
                            >
                              确认取消
                            </div>
                          </div>
                        </div>
                      </Balloon>
                    </div>
                  );
                })
              }
            </div>
          </div> 
          : 
          <div className="leads-card-content-history-empty">
            <div className="leads-card-content-history-empty-back" onClick={this.handleBackToForm}>
              <img src="https://img.alicdn.com/imgextra/i4/O1CN010UYxV21jYX5wyxdHB_!!6000000004560-2-tps-212-40.png" className="leads-card-content-history-empty-back-icon" />
            </div>
            <div className="leads-card-content-history-empty-content">
              <img src="https://img.alicdn.com/imgextra/i3/O1CN0177V87120FcChWBLuN_!!6000000006820-2-tps-480-260.png" className="leads-card-content-history-empty-content-icon" />
            </div>
          </div>
        }
      </div>
    );
  }

  renderCard() {
    const {
      showHistory
    } = this.state;
    //console.log(isNeedVerification)

    return (
      <div className="leads-card-content">
        <div className="leads-card-title">
          <div className="leads-card-title-left">
            <img 
              src="https://img.alicdn.com/imgextra/i4/O1CN01EovnQz27768t4lmBx_!!6000000007749-2-tps-64-64.png"
              className="leads-card-title-icon"
            />
            <div className="leads-card-title-text">采购助手</div>
          </div>
          
          <div className="leads-card-content-close" onClick={this.handleClose}></div>
        </div>

        {
          showHistory ?
          this.renderHistory() :
          this.renderForm()
        }
      </div>
    );
  }

  render() {
    
    return (
      <div className="leads-card-container">
        {
          this.state.cardShowState ? 
            this.renderCard()
          : 
            <div className="leads-card-icon" onClick={this.handleOpen}>

            </div>
        }
      </div>
    );
  }
}